/** @jsxImportSource @emotion/react */
import moment from "moment";
import { StyledText } from "../../assets/typography/typography";
import { CircleContainer } from "../../components/CircleContainer";
import { colors } from "../../components/colors";
import { ReactComponent as Logo } from "./../../assets/images/logo/Logo.svg";
import { css } from "@emotion/react";
import { breakpoints } from "../../components/breakpoints";

const footerWrapperStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.white};
  padding-top: 24px;
  padding-bottom: 24px;
  border-top: 1px solid ${colors.ctaInactive};
  ${breakpoints.tablet} {
    padding-left: 16px;
    padding-right: 16px;
  }
`;

const containerStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  max-width: 1200px;
`;

const subComponentsStyle = css`
  display: flex;
  flex-direction: row;
  align-items: start;
  width: 100%;
  justify-content: space-between;
  ${breakpoints.tablet} {
    flex-direction: column;
  }
`;

const logoSubtitleStyle = css`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  align-items: center;
`;

const textStyle = css`
  margin-bottom: 0px;
  white-space: nowrap;
  color: ${colors.textSecondary} !important;
`;

const linksWrapperStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  width: fit-content;
  gap: 16px;
  ${breakpoints.tablet} {
    margin-top: 32px;
  }
`;

const linkStyle = css`
  text-decoration: none !important;
`;

const linkTextStyle = css`
  color: ${colors.textSecondary} !important;
  &:hover {
    color: ${colors.textPrimary} !important;
  }
  margin-bottom: 0px;
`;

const truncateWrapper = css`
  overflow: hidden;
  width: 100%;
`;
const truncateText = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const version = process.env.REACT_APP_VERSION || "local";

export const Footer = () => {
  return (
    <footer css={footerWrapperStyle}>
      <div css={containerStyle}>
        <Logo />
        <div css={subComponentsStyle}>
          <div css={logoSubtitleStyle}>
            <StyledText css={textStyle} className="bodySubtextWide">
              © {moment().format("YYYY")}.
            </StyledText>
            <CircleContainer
              height="4px"
              width="4px"
              backgroundColor={colors.ctaInactive}
            />
            <div css={truncateWrapper}>
              <StyledText
                css={[textStyle, truncateText]}
                className="bodySubtextWide"
              >
                Version: {version}
              </StyledText>
            </div>
          </div>
          <div css={linksWrapperStyle}>
            <a css={linkStyle} href="http://www.heapsgo.com">
              <StyledText
                css={linkTextStyle}
                className="bodySubtextRegular"
                color={colors.textPrimary}
              >
                About
              </StyledText>
            </a>
            <CircleContainer
              height="4px"
              width="4px"
              backgroundColor={colors.ctaInactive}
            />
            <a href="http://www.heapsgo.com/about" css={linkStyle}>
              <StyledText
                css={linkTextStyle}
                className="bodySubtextRegular"
                color={colors.textPrimary}
              >
                Contact
              </StyledText>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
